export function listScrollParents(element) {
  let scrollingParents = listScrollParentsForElement(element);
  scrollingParents.push(window);
  let iframeElement = window.parent.document.getElementById('iframe-composer-container');
  if (iframeElement) {
    let iframeScrollingParents = listScrollParentsForElement(iframeElement);
    scrollingParents.push(...iframeScrollingParents);
  }
  return scrollingParents;
}
function listScrollParentsForElement(element) {
  let scrollingParents = [];
  while (element.parentElement) {
    if (isScrolling(element)) {
      scrollingParents.push(element);
    }
    element = element.parentElement;
  }
  return scrollingParents;
}
function isScrolling(e) {
  let {
    overflow,
    overflowX,
    overflowY
  } = getComputedStyle(e);
  if (/auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX)) {
    return true;
  }
  return false;
}